import { Link } from 'wouter';
import dataTestids from '../constants/test-ids';
import BCorp from '../svg/BCorp';
import FlexibleLink from '../util/FlexibleLink';
import LinkedInButton from './LinkedInButton';
import { MovingWorldsBannerLogo } from './MovingWorldsLogo';
import { ROUTES } from '../routes/consts';

/** Bottom-most gray and white footer areas at the bottom of every page */
const PageFooter = () => {
  return (
    <div className='border-t border-gray-100'>
      {/* Gray link panel */}
      <div className='mx-4 md:px-10 py-12 sm:py-16 bg-white flex flex-col sm:flex-row flex-wrap items-start sm:items-center justify-left text-brand-500'>
        <div className='w-[224px]'>
          <div data-testid={dataTestids.LAYOUT.FOOTER.LOGO}>
            <Link to={ROUTES.HOME}>
              <MovingWorldsBannerLogo />
            </Link>
          </div>
        </div>
        <div className='mt-8 w-full grid grid-cols-2 sm:flex gap-y-3 sm:gap-8 font-bold text-gray-400'>
          <FlexibleLink href='/about' type='legacy'>
            Our story
          </FlexibleLink>
          <FlexibleLink href='/about#careers-and-jobs-at-movingworlds' type='legacy'>
            Careers
          </FlexibleLink>
          <FlexibleLink
            href='https://zsupport.movingworlds.org/portal/en/kb/movingworlds-faqs'
            type='external'
          >
            FAQ
          </FlexibleLink>
          <FlexibleLink href='https://blog.movingworlds.org' type='external'>
            Blog
          </FlexibleLink>
          <FlexibleLink href='/contact-form-details?no_cache=1' type='legacy'>
            Contact us
          </FlexibleLink>
        </div>
      </div>
      {/* This header needs mx-4 because it does not respect the parent's margins */}
      <hr className='mx-4' />
      <div className='mt-8 mb-4 px-4 md:px-10 flex flex-col sm:flex-row sm:items-center gap-4 text-base text-gray-400'>
        <span className=''>
          © {new Date().getFullYear().toString()}{' '}
          <span className='underline'>
            <FlexibleLink href='/' type='legacy'>
              MovingWorlds
            </FlexibleLink>
          </span>
          <span>. All rights reserved</span>
        </span>
        <FlexibleLink href='/terms-of-use' type='legacy' newTab>
          Terms
        </FlexibleLink>
        <FlexibleLink href='/privacy-policy' type='legacy' newTab>
          Privacy
        </FlexibleLink>
        <div className='ml-auto flex items-center gap-6 sm:contents'>
          <div className='mb-1 sm:mb-0 ml-auto fill-white'>
            <LinkedInButton />
          </div>
          <div className='w-[43px] h-[72px] fill-gray-500'>
            <BCorp />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageFooter;
